import React, { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { useLocation } from 'react-router-dom';

const SidebarLink = styled(Link)`
  display: flex;
  color: #fff;
  justify-content: space-between;
  align-items: center;
  list-style: none;
  height: 29px;
  text-decoration: none;
  font-size: 1.375rem;
  margin-bottom: 40px;
 
  &:hover {
    // background: #F2EDE5;
    // border-left: 4px solid green;
    cursor: pointer;
     color: #fff;
  }
`;
 
const SidebarLabel = styled.span`
  // margin-left: 8px;
  font-size: medium;
`;
 
const DropdownLink = styled(Link)`
  // background: transparent;
  height: auto;
  padding-left: 3.8rem !important;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #fff;
  font-size: 0.838rem !important;
  border-left: 4px solid transparent;
  position: relative;
 
  &:hover {
    // background: green;
    cursor: pointer;
    color: #fff;
    border-left: 4px solid #f2f2f2;
  }
 
`;
 
const Menu = ({ item, onMenuClick }) => {
  const location = useLocation();
  const [subnav, setSubnav] = useState(false);
  const showSubnav = () => {
    setSubnav(!subnav);
  };

  const handleMenuItemClick = () => {
    if (onMenuClick) {
      onMenuClick();
    }
  };

  return (
    <>
    
      <SidebarLink to={item.path} 
      onClick={(e) => {
        if (item.subNav) {
          showSubnav();
        } else {
          handleMenuItemClick();
        }
      }} 
      className={showSubnav && location.pathname === item.path ? 'active' : ''}>
        <div>
          <img src={item.icon}></img>
          <SidebarLabel>{item.title}</SidebarLabel>
        </div>
        <div>
          {item.subNav && subnav
            ? item.iconOpened
            : item.subNav
            ? item.iconClosed
            : null}
        </div>
      </SidebarLink>
      {subnav &&
        item.subNav.map((subItem, index) => {
          return (
            <DropdownLink
              to={subItem.path}
              key={index}
              onClick={handleMenuItemClick}
            >
              <SidebarLabel className={location.pathname === subItem.linkpath ? 'sub_active' : ''}>{subItem.title}</SidebarLabel>
            </DropdownLink>
          );
        })}
    </>
  );
};
 
export default Menu;